import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.button<{ cor: string }>`
  width: 100%;
  aspect-ratio: 1;
  position: sticky;
  right: 5px;
  bottom: 5px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  background-color: ${({ cor }) => cor};
  cursor: pointer;
  transition: 0.2s;
  z-index: 5;

  &:hover {
    background-color: ${({ cor }) => darken(0.1, cor)};
  }
`;
